import { Routes, Route, Navigate } from 'react-router-dom';
import { TenantProvider } from './contexts/TenantContext.tsx';
import { CartProvider } from './contexts/CartContext.tsx';
import { MenuPage } from './pages/MenuPage.tsx';
import { CartPage } from './pages/CartPage.tsx';
import { CheckoutPage } from './pages/CheckoutPage.tsx';
import { OrderStatusPage } from './pages/OrderStatusPage.tsx';
import { NotFoundPage } from './pages/NotFoundPage.tsx';
import { StaffLoginPage } from './pages/staff/StaffLoginPage.tsx';
import { StaffShell } from './pages/staff/StaffShell.tsx';
import { KitchenPage } from './pages/staff/KitchenPage.tsx';
import { StopListPage } from './pages/staff/StopListPage.tsx';
import { StatsPage } from './pages/staff/StatsPage.tsx';

export function App() {
  return (
    <Routes>
      {/* Tenant shell — all customer-facing routes */}
      <Route path="/s/:slug" element={<TenantProvider />}>
        <Route index element={
          <CartProvider>
            <MenuPage />
          </CartProvider>
        } />
        <Route path="cart" element={
          <CartProvider>
            <CartPage />
          </CartProvider>
        } />
        <Route path="checkout" element={
          <CartProvider>
            <CheckoutPage />
          </CartProvider>
        } />
        <Route path="order/:orderId" element={<OrderStatusPage />} />
      </Route>

      {/* Staff routes */}
      <Route path="/staff/login" element={<StaffLoginPage />} />
      <Route path="/staff" element={<StaffShell />}>
        <Route index element={<Navigate to="/staff/kitchen" replace />} />
        <Route path="kitchen" element={<KitchenPage />} />
        <Route path="stoplist" element={<StopListPage />} />
        <Route path="stats" element={<StatsPage />} />
      </Route>

      {/* Root redirect — show first tenant in dev, 404 in prod */}
      <Route path="/" element={<Navigate to="/s/dym-mangala" replace />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
